import styled from "@emotion/styled"
import colors from "theme/colors"
import { NewText } from "ui"
import { extractProperty } from "utils"

const StyledBoxItem = styled.div<{ $index: number }>`
  width: 45%;
  border-bottom: ${(p) =>
    (p.$index === 0 || p.$index === 1) && "2px dotted white;"};
  padding: 12px 8px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 12px 10px 13px 10px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 12px 16px 20px 16px;
  }
  p {
    margin: 0;
  }
`

type BoxItemProps = {
  item: any
  index: number
}

function BoxItem({ item, index }: BoxItemProps) {
  const blockTopTitle = extractProperty(item, "blockTopTitle")
  const blockNumberTitle = extractProperty(item, "blockNumberTitle")
  const blockInnerText = extractProperty(item, "blockInnetText")

  return (
    <StyledBoxItem $index={index}>
      <NewText
        largeDesktopFontSize={20}
        largeDesktopLineHeight="28px"
        desktopFontSize={14}
        desktopLineHeight={"19.6px"}
        mobileFontSize={16}
        mobileLineHeight={"24px"}
        component={"h3"}
        color={colors.white}
        desktopFontWeight={500}
      >
        {blockTopTitle}
      </NewText>
      <NewText
        largeDesktopFontSize={72}
        largeDesktopLineHeight="80px"
        desktopFontSize={48}
        desktopLineHeight={"53.33px"}
        mobileFontSize={40}
        mobileLineHeight={"48px"}
        desktopFontWeight={500}
        component={"p"}
        color={colors.white}
        dir="ltr"
        textAlign="left"
      >
        {blockNumberTitle}
      </NewText>
      <NewText
        largeDesktopFontSize={20}
        largeDesktopLineHeight="28px"
        desktopFontSize={14}
        desktopLineHeight={"19.6px"}
        mobileFontSize={14}
        mobileLineHeight={"20px"}
        component={"p"}
        color={colors.white}
        dangerouslySetInnerHTML={{ __html: blockInnerText }}
      />
    </StyledBoxItem>
  )
}

export default BoxItem
